import { type PropsWithChildren, createContext, useContext, useEffect, useMemo } from 'react'
import { useParams } from 'react-router'
import { useClickToTextPageContext } from 'pages/clickToText/context'
import { ClickToTextDetailsStore } from 'pages/clickToText/pages/viewClickToText/store'

const ClickToTextDetailsContext = createContext<ClickToTextDetailsStore | null>(null)

export const useClickToTextDetailsContext = () => {
  const context = useContext(ClickToTextDetailsContext)

  if (context === null)
    throw new Error(
      'You have forgotten to wrap your root component with ClickToTextDetailsProvider'
    )

  return context
}

export const ClickToTextDetailsProvider = ({ children }: PropsWithChildren) => {
  const { id } = useParams()
  const { pageLayoutStore, entities } = useClickToTextPageContext()
  const store = useMemo(() => new ClickToTextDetailsStore(id, pageLayoutStore, entities), [])

  useEffect(() => {
    void store.init()
    entities.inboxesStore.fetchInboxes()

    return store.dispose
  }, [])

  return (
    <ClickToTextDetailsContext.Provider value={store}>
      {children}
    </ClickToTextDetailsContext.Provider>
  )
}
